import { PropsWithChildren } from 'react';

import Loader from '../loader/loader';

import styles from './flat-button.module.scss';

interface Props extends PropsWithChildren {
    disabled?: boolean;
    loading?: boolean;
    onClick?: () => void;
}

const FlatButton = ({ children, disabled, loading, onClick }: Props) => (
    <button
        className={styles.flatButton}
        onClick={onClick}
        disabled={loading || disabled}
    >
        {loading ? <Loader size={18} color="#949fb4" /> : children}
    </button>
);

export default FlatButton;
